import { render, staticRenderFns } from "./GroupHome.vue?vue&type=template&id=2106e9c5&"
import script from "./GroupHome.vue?vue&type=script&lang=js&"
export * from "./GroupHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports